import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { IEstatusJson } from '../../../authmanagement/models/IEstatusJson';
import { IApiBase } from './Interface/IApiBase.interface';
import { CatalogPaginationRequest } from '../../models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from '../../models/Filter/FilterRequest';

@Injectable({
  providedIn: 'root'
})
export class UserConfigurationAPIService implements IApiBase{
  configUrl: string;
  public clientes: any = [];

    constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error('Method not implemented.');
  }
  update(datos: any) {
    throw new Error('Method not implemented.');
  }
  delete(id: any) {
    throw new Error('Method not implemented.');
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error('Method not implemented.');
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error('Method not implemented.');
  }


  getUserRoles() {
    //todo cambiar controlador cuando esté listo
    console.log("/api/AuthManagement/GetUserRoles/");
    return this.http.get<IEstatusJson>(this.configUrl + "/api/authmanagement/GetUserRoles");
  }

  public GetByUserIdWithDefault() {
    console.log("/api/UserConfiguration/GetByUserIdWithDefault");
    return this.http.get<IEstatusJson>( this.configUrl + "/api/UserConfiguration/GetByUserIdWithDefault");
  }

}
